module.exports = __webpack_public_path__ + "img/car.79af8f0.svg";